import { MenuItem, Pagination, Stack } from '@mui/material';
import { Select } from '@mui/material';
import { PAGE_SIZE } from '../../config';
import { FormattedMessage } from 'react-intl';

type Props = Readonly<{
	totalCount: number;
	pageSize: number;
	page: number;
	setPage: (page: number) => void;
	setPageSize: (pageSize: number) => void;
}>;

function Paginator(props: Props): React.ReactElement | null {
	const totalCount = Math.ceil(props.totalCount / props.pageSize) || 1;

	return (
		<Stack direction={'row'} marginTop={2} justifyContent={'end'} gap={1}>
			<Pagination
				count={totalCount}
				page={props.page}
				onChange={(event, page) => props.setPage(page)}
				variant={'outlined'}
				size={'medium'}
				shape={'rounded'}
			/>
			<Select
				value={props.pageSize}
				size={'small'}
				onChange={(event) => {
					props.setPageSize(event.target.value as number);
					props.setPage(1);
				}}
			>
				<MenuItem value={PAGE_SIZE}>
					<FormattedMessage id={`paginator.pagesize`} values={{ count: PAGE_SIZE }} />
				</MenuItem>
				<MenuItem value={20}>
					<FormattedMessage id={'paginator.pagesize'} values={{ count: 20 }} />
				</MenuItem>
				<MenuItem value={30}>
					<FormattedMessage id={'paginator.pagesize'} values={{ count: 30 }} />
				</MenuItem>
			</Select>
		</Stack>
	);
}

export default Paginator;
